import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-checkout.outlet',
  templateUrl: './checkout.outlet.component.html',
  styleUrls: ['./checkout.outlet.component.css'],
})
export class CheckoutOutletComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription;
  isCheckoutPage = false;

  constructor(private router: Router) {
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd =>
            event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        // Only block scroll for checkout pages, not for other order pages
        this.isCheckoutPage = event.url.includes('/checkout/');

        if (this.isCheckoutPage) {
          document.body.classList.add('checkout-page');
        } else {
          document.body.classList.remove('checkout-page');
        }
      });
  }

  ngOnInit(): void {
    // Check initial route
    this.isCheckoutPage = this.router.url.includes('/checkout/');
    if (this.isCheckoutPage) {
      document.body.classList.add('checkout-page');
    }
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    // Always remove checkout-page class when leaving
    document.body.classList.remove('checkout-page');
  }
}
